import { render, staticRenderFns } from "./DropdownField.vue?vue&type=template&id=be090894&scoped=true&"
import script from "./DropdownField.vue?vue&type=script&lang=ts&"
export * from "./DropdownField.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownField.vue?vue&type=style&index=0&id=be090894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be090894",
  null
  
)

export default component.exports